import {
    Medication
  } from 'one-state-medication/src/medication';
import { formatIso } from 'one-util-date';

export const sortFunction = (a: Medication, b: Medication) => {
    const dateA = new Date(a.startdate);
    const dateB =new Date(b.startdate);
    return dateB.getTime() - dateA.getTime();
}


/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Medication Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */


export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    // let result: Medication[] = [];
    let result :any = {
        medication:[],
        error:undefined
    }

    const { log,settings } = context;
    const {uisettings:{dateformat}} = settings
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }

    if (response && response.length > 0) {
        const rs = response;
        let medicationarray:Medication[] = [];
        rs.map((ele: any) => {
            if(ele.MedicationOrders && ele.MedicationOrders.length > 0){
                ele.MedicationOrders.map ((medicationdata: any) => {
                    let medicationobj : Medication ={
                        name :"",
                        patientsig:"",
                        startdate:"",
                        enddate:"",
                        refillsremaining:""
                    }
                    medicationobj.name = medicationdata.Name ? medicationdata.Name:"";
                    medicationobj.patientsig =medicationdata.PatientSig ? medicationdata.PatientSig:"";
                    medicationobj.startdate = medicationdata.StartDate ? formatIso(medicationdata.StartDate, dateformat):"";
                    medicationobj.enddate = medicationdata.EndDate ? formatIso(medicationdata.EndDate, dateformat):"";
                    medicationobj.refillsremaining = medicationdata.RefillsRemaining ? medicationdata.RefillsRemaining:"";
                    medicationarray.push(medicationobj);
                })
            }
        });
        result.medication = medicationarray;
    }
    log.debug(
        "ccw-gadget,medication-epic",
        "medication-epic transforamtion response ", {
        result
    });
    result.medication.sort(sortFunction);
    return result;
}